import { render, staticRenderFns } from "./BackPageFull.vue?vue&type=template&id=a2f76b20&scoped=true"
import script from "./BackPageFull.vue?vue&type=script&lang=js"
export * from "./BackPageFull.vue?vue&type=script&lang=js"
import style0 from "./BackPageFull.vue?vue&type=style&index=0&id=a2f76b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f76b20",
  null
  
)

export default component.exports